import { extraPermissions, ExtraPermissionsReturn } from './extra-permission-handler';
import { proPermissions, ProPermissionsReturn } from './pro-permission-handler';

export class PermissionHandler {
    // Handlers
    private _pro: ProPermissionsReturn;
    private _extra: ExtraPermissionsReturn;

    constructor(lang = 'fr') {
        this._pro = proPermissions(lang);
        this._extra = extraPermissions(lang);
    }

    //
    // ─── GETTERS ────────────────────────────────────────────────────────────────────
    //

    get pro(): ProPermissionsReturn {
        return this._pro;
    }

    get extra(): ExtraPermissionsReturn {
        return this._extra;
    }
}
